import BaseEditor from '../BaseEditor/BaseEditor';
import { useEffect, useState } from 'react';
import ShowIf from '../../components/UI/ShowIf';
import SplashScreenLoading from '../../components/SplashScreenLoading/SplashScreenLoading';
import { CARTA_SETTINGS } from '../../settings/CartaSettings';
import useDynamicImageLoading from '../../hooks/useDynamicImageLoading';
import {EX_LIBRIS_SETTINGS} from "../../settings/ExLibrisSettings";

const galleriesBasePath: any = {
  fondos: `images/fondos/`,
  texturas: `images/texturas/`,
  detalles: `images/cartas/detalles/`,
  fechas: `images/cartas/fechas/`,
  frases: `images/cartas/frases/`,
};

function Carta() {
  const selectedCategorySettings = CARTA_SETTINGS;
  const [settings, setSettings] = useState<any>(null);
  const [loadingImages, updatedSelectedCategorySettings] = useDynamicImageLoading(
      selectedCategorySettings,
      galleriesBasePath
  );

  useEffect(() => {
    if (loadingImages) {
      return;
    }

    setSettings(updatedSelectedCategorySettings);
  }, [loadingImages]);

  return (
    <ShowIf condition={!!settings} elseChildren={<SplashScreenLoading />}>
      <BaseEditor workArea={{ height: 901, width: 633 }} selectedCategorySettings={settings} />
    </ShowIf>
  );
}

export default Carta;
